module.exports = __webpack_public_path__ + "img/calapan-elib.a8dd0ddb.jpg";